import { useState, useEffect } from 'react'
import api from '../lib/api'

export default function Backup() {
  const [tenants,    setTenants]    = useState([])
  const [tenantId,   setTenantId]   = useState('')
  const [tenant,     setTenant]     = useState(null)
  const [loading,    setLoading]    = useState(false)
  const [error,      setError]      = useState(null)
  const [success,    setSuccess]    = useState(null)

  useEffect(() => {
    api.get('/tenants?per_page=100').then(({ data }) => setTenants(data.data ?? []))
  }, [])

  useEffect(() => {
    if (!tenantId) { setTenant(null); return }
    const t = tenants.find(t => t.id === tenantId)
    setTenant(t ?? null)
    setError(null)
    setSuccess(null)
  }, [tenantId, tenants])

  async function descargarJson() {
    if (!tenantId) return
    setLoading(true)
    setError(null)
    setSuccess(null)
    try {
      const res = await api.get(`/tenants/${tenantId}/backup/json`, { responseType: 'blob' })
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/zip' }))
      const filename = res.headers['content-disposition']?.match(/filename="?([^"]+)"?/)?.[1]
        ?? `backup_${tenant?.nit ?? tenantId}.zip`
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
      setSuccess(`ZIP descargado correctamente — ${filename}`)
    } catch (err) {
      if (err.response?.data instanceof Blob) {
        const text = await err.response.data.text()
        const json = JSON.parse(text)
        setError(json.message ?? 'Error al generar el backup.')
      } else {
        setError(err.response?.data?.message ?? 'Error al generar el backup.')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="topbar">
        <div className="breadcrumb"><strong>Files</strong> — Backup</div>
      </div>

      <div className="content">
        <div className="panel" style={{ maxWidth: '600px' }}>
          <div className="panel-head">Descargar JSON de tenant</div>
          <div className="panel-body" style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
            <p style={{ fontSize: '13px', color: 'var(--muted)', margin: 0 }}>
              Genera un ZIP con todos los documentos DTE firmados (JSON) del tenant seleccionado.
              No incluye datos sensibles de configuración.
            </p>

            {/* Selector */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>CLIENTE</label>
              <select
                className="form-input"
                value={tenantId}
                onChange={e => setTenantId(e.target.value)}
                style={{ height: '36px', fontSize: '13px' }}
              >
                <option value="">— Selecciona un cliente —</option>
                {tenants.map(t => (
                  <option key={t.id} value={t.id}>{t.company_name}</option>
                ))}
              </select>
            </div>

            {/* Info del tenant seleccionado */}
            {tenant && (
              <div style={{ background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '8px', padding: '12px 16px', display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                <div>
                  <div style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>NIT</div>
                  <div className="mono" style={{ fontSize: '13px', marginTop: '2px' }}>{tenant.nit}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>SUBDOMINIO</div>
                  <div className="mono" style={{ fontSize: '13px', marginTop: '2px' }}>{tenant.subdomain}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>AMBIENTE</div>
                  <div style={{ marginTop: '2px' }}>
                    {tenant.ambiente === '01'
                      ? <span className="badge badge-prod">Producción</span>
                      : <span className="badge badge-test">Pruebas</span>}
                  </div>
                </div>
              </div>
            )}

            {error   && <div className="error-banner">⚠ {error}</div>}
            {success && <div style={{ background: '#d1fae5', border: '1px solid #6ee7b7', color: '#065f46', borderRadius: '8px', padding: '10px 14px', fontSize: '13px' }}>✓ {success}</div>}

            <button
              className="btn btn-primary"
              disabled={!tenantId || loading}
              onClick={descargarJson}
              style={{ alignSelf: 'flex-start' }}
            >
              {loading ? 'Generando ZIP…' : '↓ Descargar JSON (ZIP)'}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
